import { isNullOrEmpty } from 'helpers/generalHelpers';
import React, { useState, useMemo, useRef } from 'react'
import { medsCreateState, createMedsStep } from 'store/storeValtio';
import { formType } from '../dropdownOptions';

export default function MedicationDosage({prevStep, nextStep}) {
  const [dosageType, setDosageType] = useState(null);
  const [error, setError] = useState(null);
  //console.log('MedDosage', medsCreateState.dosage);

  const dosageUnit = useRef();
  const initialUnit = useRef();
  const form = useMemo(() => formType(medsCreateState.form),[]);

  const dosageTypeList = useMemo(() => [
    { 'descr': 'Tsp', 'code': 'TSP' },
    { 'descr': 'Tbsp', 'code': 'TBSP' },
    { 'descr': 'Drops', 'code': 'DROPS' },
    { 'descr': 'ML', 'code': 'ML' },
  ],[]);

  const dosageList = useMemo(() => [
      { 'descr': '1/8', 'code': '0.125' },
      { 'descr': '1/4', 'code': '0.25' },
      { 'descr': '1/2', 'code': '0.5' },
      { 'descr': '1', 'code': '1' },
      { 'descr': '1 1/2', 'code': '1.5' },
      { 'descr': '2', 'code': '2' },
      { 'descr': '3', 'code': '3' },
      { 'descr': '4', 'code': '4' },
      { 'descr': '5', 'code': '5' },
      { 'descr': 'Other', 'code': 'O' },
      { 'descr': 'Select Dosage', 'code': 'S' },
  ],[]);

  useMemo(() => {
    var dosage = medsCreateState.dosage;
    //console.log('UE', dosage, typeof dosage);
    if (dosage && typeof dosage === 'number') dosage = dosage.toString();
    //var regexp = /^(\d+(?:\.+\d*)?)([A-Za-z]+)$/
    if (dosage) {
      var regexp = /^(\d+(?:\.\d+)?)([A-Za-z]+)?$/
      const parts = dosage.match(regexp);
      //console.log('parts', dosage, parts);
      if (!parts) {
        initialUnit.current = dosage;
        if (dosage === 'Other') dosageUnit.current = 'O';
        setDosageType(null);
      }else if (parts.length === 3) {
        dosageUnit.current = parts[1];
        setDosageType(parts[2]);
        const d = dosageList.find(d => d.code === parts[1]);
        //console.log('find', parts[1], d);
        if (!d) {
          initialUnit.current = parts[1];
          dosageUnit.current = 'S';
          //console.log('initialUnit', parts[1]);
        }
      }
    }
    //console.log('end useMemo');
  },[])

  function selectDosage(n) {
    console.log('selectDosage', n);
    var dose = null;
    if (n.code === 'O') {
      medsCreateState.dosage = 'Other';
      nextStep(createMedsStep.often);
      return;
    } 
    if (n.code === 'S') {
      let input = document.getElementById("dose"); 
      dose = input.value;
      //console.log('dose', dose, typeof dose);
      if (!input || isNullOrEmpty(dose)) {
        setError("Please enter a dosage amount");
        return;
      }
      dosageUnit.current = dose;
    } else {
      dose = n.code;
      console.log('dose', dose, typeof dose);
    }
    medsCreateState.dosage = dose;
    //console.log('dosageType', dosageType);
    if (dosageType) {
      medsCreateState.dosage = dose + dosageType;
      //setError(null);
    } else if (form === 'V') {
      setError('Please select a dosage type');
      return;
    }
    //console.log('selectDosage', medsCreateState.dosage)
    nextStep(createMedsStep.often);
  }

  function typeChanged(e) {
    //console.log('typeChanged',e.target.value);
    //e.target.checked = true;
    setDosageType(e.target.value);
    if (error) setError(null);
  }

  const medsHowMuch = formType(medsCreateState.form) === 'V';
  const manyMuch = medsHowMuch ? 'much': 'many';

    return (
      <>
        <div className='medBody text-center'>
          <b>How {manyMuch}</b> do you take each time?
        </div>
        {error && (
          <div
            className='bg-red-100 rounded-lg p-2 mx-10 mb-3 text-base text-red-700'
            role='alert'
          >
            {error}
          </div>
        )}
        {medsHowMuch &&
        <div className = "w-full flex flex-col justify-center py-2">
          <div className = "w-full flex justify-center">
            <div className = "flex flex-row justify-around w-9/12 font-semibold">
            {dosageTypeList.map((d,ix) => {
              const sel = d.code === dosageType;
              //console.log('sel', sel, d.code, dosageType);
              return (
                <div key={ix} className='flex justify-center items-center'> 
                  <input 
                    onChange={typeChanged} 
                    type="radio" 
                    value={d.code} 
                    name="amount" 
                    checked={sel}
                    />
                    <div className='ml-2'>
                      {d.descr} 
                    </div>
              </div>
              )
            })}
            </div>
          </div>
        </div>
        }
        <div className='medList'>
          {dosageList.map((d,ix) => {
            const li = d.code === dosageUnit.current ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
            return (
              <div
                key={ix} 
                className={'medCard ' + li} 
                onClick={()=>selectDosage(d)} 
                id={d.code}>
                  {d.descr}
                </div>
              )
            })
          }
        </div>
        <div className='flex flex-col justify-center mt-4'>
          <div className='h-10 text-xl font-bold text-center'>
            Select the dosage amount
          </div>
          <div className='flex justify-center px-4'>
            <input 
              className='w-3/12 text-xl mr-4'
              id='dose'
              name='dose'
              type='number'
              defaultValue={initialUnit.current}
            />
          </div>
        </div>
      </>
      );
    }
